import React from 'react';

function IconWarning({
  width = '1rem',
  style,
  viewBox = '0 0 24 24',
  className,
  fill = 'currentColor',
}) {
  return (
    <svg
      width={width}
      style={style}
      height={width}
      viewBox={viewBox}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={fill}
        fillRule="nonzero"
        d="M12 2c5.524 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 2c-4.411 0-8 3.589-8 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8zm0 11a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm0-8c.552 0 1 .522 1 1.167v4.666c0 .645-.448 1.167-1 1.167s-1-.522-1-1.167V8.167C11 7.522 11.448 7 12 7z"
      />
    </svg>
  );
}
export default IconWarning;
